module.exports = __webpack_public_path__ + "img/qr_ivy_logo.425e9eee.png";